import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { DataService, PlayerService } from "/Users/curtis/Downloads/Listen.FM_Build_myself/source_4.2.2020/fm181/src/_services/index";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html"
})
export class HomeComponent implements OnInit {
  items: any[];
  categories: any[];
  stations: any[];
  constant: any[];

  constructor(private dataService: DataService, private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle("Listen.FM");

    this.dataService.callPlaylist().subscribe(result => {
      this.items = this.dataService.getCategories();
      this.stations = this.dataService.getPopular();
    });

    this.items = this.dataService.getCategories();
    this.stations = this.dataService.getPopular();

    this.constant = this.dataService.getConstant();
    if (Object.keys(this.constant).length === 0) {
      this.dataService.callConstants().subscribe(result => {
        this.constant = result;
      });
    }
  }
}
